import React, { useCallback, useEffect } from "react";
import FiltersChartDrawer from "./FiltersChartDrawer";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../../../reducers/painelAlerta.actions";
import {
  getDominioDispositivos,
  getDominioEmpresas,
  getDrawerChart,
  getFiltrosChart,
} from "../../../../selectors/painelAlerta.selectors";
import useCompleteForm from "../../../../hooks/useCompleteForm";
import { getUsuario } from "../../../../selectors/usuario.selectors";
import validators from "../../../../utils/validators";

const FilterDrawerConnected = () => {
  const dispatch = useDispatch();
  const { filters: filtersVisible } = useSelector(getDrawerChart);
  const filtros = useSelector(getFiltrosChart);
  const { empresa } = useSelector(getUsuario);
  const { data: dataEmpresas } = useSelector(getDominioEmpresas);
  const { data: dataDispositivos } = useSelector(getDominioDispositivos);

  const handleClose = useCallback(() => {
    dispatch(actions.exibirFiltrosChart(false));
  }, [dispatch]);

  const [formProps, handleSubmit] = useCompleteForm({
    rules: (f) => ({
      empresa: validators.string({
        required: false,
      }),
    }),
    initialValues: () => ({
      empresa: dataEmpresas.find((el) => el.id === empresa) ?? null,
      roteiro: "",
      dispositivo: null,
      ordem: "inicio",
    }),
    handleSubmit: (values) => {
      dispatch(actions.atualizarFiltrosChart({ ...values }));
      handleClose();
    },
  });

  const { reset } = formProps;

  useEffect(() => {
    if (!!filtersVisible && !!filtros) {
      reset(filtros);
    }
  }, [filtros, reset, filtersVisible]);

  useEffect(() => {
    if (dataEmpresas.find((el) => el.id === empresa)) {
      dispatch(
        actions.atualizarFiltros({
          empresa: dataEmpresas.find((el) => el.id === empresa),
        })
      );
    }
    // eslint-disable-next-line
  }, [empresa, dataEmpresas]);

  useEffect(() => {
    if (empresa === null) {
      dispatch(actions.atualizarFiltros());
    }
    // eslint-disable-next-line
  }, [empresa]);

  return (
    <FiltersChartDrawer
      handleClose={handleClose}
      visible={filtersVisible}
      formProps={formProps}
      handleSubmit={handleSubmit}
      showEmpresa={!empresa}
      domainEmpresas={dataEmpresas}
      domainDispositivos={dataDispositivos}
      empresa={empresa}
    />
  );
};

export default FilterDrawerConnected;
